var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPen = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1669 3.11704L10.8836 0.833703C10.5856 0.553783 10.1951 0.393169 9.78636 0.382413C9.37764 0.371658 8.97923 0.511511 8.66691 0.77537L1.16691 8.27537C0.897552 8.54701 0.729834 8.90304 0.691914 9.2837L0.333581 12.7587C0.322355 12.8808 0.338193 13.0038 0.379965 13.119C0.421737 13.2343 0.488416 13.3389 0.575247 13.4254C0.653114 13.5026 0.745461 13.5637 0.846992 13.6052C0.948523 13.6467 1.05724 13.6677 1.16691 13.667H1.24191L4.71691 13.3504C5.09758 13.3125 5.45361 13.1447 5.72525 12.8754L13.2252 5.37537C13.5163 5.06784 13.6737 4.65746 13.6627 4.23415C13.6518 3.81084 13.4735 3.40913 13.1669 3.11704ZM10.3336 5.90037L8.10025 3.66704L9.72525 2.00037L12.0002 4.27537L10.3336 5.90037Z",
    fill: "#C59331"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editPen.1c8f6a9f4c622b706bf08d1c6ec7a926.svg";